import PropTypes from 'prop-types';
import { ContentItem, NodeName } from './style';

export function NodeSlot({ nodeData }) {
  return (
    <ContentItem style={{ opacity: '0.7', margin: '10px' }}>
      <NodeName>{nodeData.title}</NodeName>
    </ContentItem>
  );
}

NodeSlot.propTypes = {
  nodeData: PropTypes.object,
};
